import Oriola from "./oriolaAdmin";

export default Oriola;
